export default __webpack_public_path__ + "49d91203c425ef88e2310d88a39670cc.gif";